import { useTranslate } from '@/shared/i18n/I18nProvider'

export interface ErrorPanelProps {
  reset?: () => void
}

/**
 * Shown when the authenticated tree fails to load for any reason other than a
 * missing session. It deliberately renders no clinic, practitioner or menu:
 * a degraded API must not be able to produce something that reads as signed in.
 */
export function ErrorPanel({ reset }: ErrorPanelProps) {
  const t = useTranslate()
  return (
    /* The `main` landmark stays a landmark: `role="alert"` HERE would replace
       it, and every full-page error would lose the one region a landmark
       navigator jumps to. The alert is an inner wrapper instead. */
    <main id="main" className="panel panel--error">
      <div role="alert">
        <h1>{t('error.title')}</h1>
        <p>{t('error.detail')}</p>
        {reset ? (
          <button type="button" className="button" onClick={reset}>
            {t('error.retry')}
          </button>
        ) : null}
      </div>
    </main>
  )
}
